import { render, staticRenderFns } from "./Rankeds.vue?vue&type=template&id=6f3eb060&"
import script from "./Rankeds.vue?vue&type=script&lang=js&"
export * from "./Rankeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports